const cardBlacklist = {
  header: {
    btnCreate: 'Create',
  },

  forms: {
    header: {
      create: {
        title: 'Create',
      },
      update: {
        title: 'Update',
      },
    },
    create: {
      success: 'Black listed card has been added!',
      failure: 'Could not create a black listed card',
      header: 'Create Card Blacklist Item',
      footer: {
        submit: 'Submit',
      },
    },
    update: {
      footer: {
        submit: 'Update',
      },
    },
    sections: {
      details: {
        header: 'Details',
        fields: {
          number: 'Card number',
        },
      },
    },
  },
  table: {
    headers: {
      number: 'Card Number',
      site: 'Site',
    },
    actions: {
      delete: {
        modal: {
          header: 'Delete black listed cards',
          body: 'You are about to delete {{num}} black listed cards.',
        },
        success: 'Black listed cards have been successfully deleted',
      },
      create: 'Create',
    },
    floatingActions: {
      delete: 'Delete',
      export: 'Export',
    },
    
  },
};

export default cardBlacklist;
